import { inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  private sanitizer = inject(DomSanitizer);

  resizeAndDisplayImage(file: Blob, maxHeight: number): Promise<{ imageSrc: SafeUrl; blob: Blob }> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const ratio = img.width / img.height;
          const newHeight = maxHeight;
          const newWidth = newHeight * ratio;

          const canvas = document.createElement('canvas');
          canvas.width = newWidth;
          canvas.height = newHeight;
          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0, newWidth, newHeight);
          canvas.toBlob((blob: any) => {
            const imageSrc = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
            resolve({ imageSrc, blob });
          });
        };
        img.src = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    });
  }
}
